import UserDealerListRequest, {
  UserDealerListRequestStatusCriteria,
  UserDealerListRequestOrder,
} from "../../../../api/raily/user/dealer/list/user-dealer-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import DealerListParams from "./user-dealer-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserDealerListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserDealerListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserDealerListRequestStatusCriteria.DELETED;
    default:
      return UserDealerListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserDealerListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserDealerListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserDealerListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserDealerListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserDealerListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserDealerListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserDealerListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (params: DealerListParams): UserDealerListRequest => {
  return {
    taxiCorporation: params.taxiCorporation,
    taxiCorporationId: params.taxiCorporationUuid,
    firstName: params.firstName,
    lastName: params.lastName,
    username: params.username,
    email: params.email,
    statusCriteria: createStatusCriteria(params.status),
    creationStart: params.creationDateFrom,
    creationEnd: params.creationDateTo,
    order: createOrder(params.order),
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
  };
};

const userDealerListParamsFactory = { create };

export default userDealerListParamsFactory;
